import { useState, useEffect, useRef } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";

type TextInputProps = Omit<TextFieldProps, 'onChange' | 'value'> & {
  initialValue: string;
  onChange: (value: string) => void;
  debounceMs?: number;
};

export const TextInput = ({ initialValue, onChange, debounceMs = 500, ...props }: TextInputProps) => {
  const [localValue, setLocalValue] = useState(initialValue);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setLocalValue(initialValue);
  }, [initialValue]);

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    
    setLocalValue(event.target.value);

    timerRef.current = setTimeout(() => {
      onChange(event.target.value);
    }, debounceMs);
  }

  return (
    <TextField
      {...props}
      value={localValue}
      onChange={handleChange}
    />
  );
};
